import { apiClient } from './client';
import type { ApiResponse } from '@/types/api.types';

/** Body for POST /api/v1/documents/email. The PDF is generated client-side and sent as base64. */
export interface SendDocumentEmailRequest {
  toRecipients:        string[];
  ccRecipients:        string[];
  subject:             string;
  body:                string;
  documentType:        string;          // e.g. "GL Journal" — used for the audit trail / default subject
  documentNo?:         string | null;
  attachmentBase64?:   string | null;   // PDF bytes, base64, no data-URI prefix
  attachmentFileName?: string | null;
}

export const documentEmailApi = {
  /** POST /api/v1/documents/email — send a transaction document to recipients via SMTP. */
  send: (req: SendDocumentEmailRequest) =>
    apiClient.post<ApiResponse<void>>('/documents/email', req),
};
